<template>
  <div>
    <filters-bar titleClass="headline" :downloadButton="false" title="Hoy" dateType="all" />
    <v-layout row wrap justify-center>
      <v-flex ml-3 md-3 :key="`card-${i}`" pr-3>
        <v-card ripple hover>
          <v-card-title primary-title class="text-xs-center pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <p class="subheading">
                  Cartera
                </p>
              </v-flex>
              <v-flex xs12>
                <p class="body-2">
                  {{ new Intl.NumberFormat('es-VE').format(2500) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex ml-3 md-3 :key="`card-${i}`" pr-3>
        <v-card ripple hover>
          <v-card-title primary-title class="text-xs-center pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <p class="subheading">
                  Pagos
                </p>
              </v-flex>
              <v-flex xs12>
                <p class="body-2">
                  {{ new Intl.NumberFormat('es-VE').format(3500) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex ml-3 md-6 :key="`card-${i}`" pr-3>
        <v-card ripple hover>
          <v-card-text class="pt-4">
            <v-layout>
              <v-flex class="text-xs-center" md6>
                <v-flex xs12>
                  <span class="subheading">
                    Gestiones IN
                  </span>
                </v-flex>
                <v-flex xs12>
                  <p class="body-2">
                    {{ new Intl.NumberFormat('es-VE').format(3500) }}
                  </p>
                </v-flex>
              </v-flex>
              <v-flex>
                <v-divider
                class="vertical mx-3"
                inset
                ></v-divider>
              </v-flex>
              <v-flex class="text-xs-center" md6>
                <v-flex xs12>
                  <span class="subheading">
                    Gestiones IN
                  </span>
                </v-flex>
                <v-flex xs12>
                  <p class="body-2">
                    {{ new Intl.NumberFormat('es-VE').format(3500) }}
                  </p>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import FiltersBar from '@/components/global/FiltersBar';

export default {
  components: {
    FiltersBar,
  },
  props: {
    channel: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      dialog: false,
      name: '',
      data: [
        {
          title: 'Gestionados',
          total: 1000,
          partial: {
            yes: 800,
            no: 50,
          },
        },
        {
          title: 'Contactados',
          total: 900,
          partial: {
            yes: 800,
            no: 100,
          },
        },
        {
          title: 'Contacto útil',
          total: 600,
          partial: {
            yes: 450,
            no: 150,
          },
        },
        {
          title: 'Compromiso',
          total: 400,
          partial: {
            yes: 250,
            no: 150,
          },
        },
      ],
    };
  },
  methods: {
    showModal(title) {
      this.name = title;
      this.dialog = true;
    },
  },
};
</script>
<style scoped>
  .arrowNext {
    margin-top: auto;
    margin-bottom: auto;
  }
  .vertical {
    border: none;
    border-left: 1px solid hsl(200, 2%, 79%);
    height: 100%;
    border-radius: 20%;
    width: 1px;
  }
</style>




// WEBPACK FOOTER //
// src/components/panel/total_day/Total.vue